var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "VPopover",
    {
      class: _vm.popoverClasses,
      attrs: {
        trigger: _vm.trigger,
        offset: _vm.offset,
        disabled: _vm.isTooltipDisabled,
        placement: _vm.placement,
        openClass: "z-30 b-tooltipZ",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "popover",
            fn: function () {
              return [
                _vm._t("tooltip", function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "tooltip popover relative",
                        class: _vm.tooltipContainerClasses,
                        attrs: { role: "tooltip" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tooltip-inner break-words",
                            class: _vm.innerClasses,
                          },
                          [
                            _vm._t("content", function () {
                              return [_vm._v(" " + _vm._s(_vm.title) + " ")]
                            }),
                          ],
                          2
                        ),
                        _c("div", {
                          staticClass: "tooltip-arrow",
                          class: _vm.arraowClass,
                        }),
                      ]
                    ),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }